module.exports = __webpack_public_path__ + "media/promo/panasonic/images/mobbg-50a2d8a2632776a4946f25746ae2c685.png";